/**
 * @generated SignedSource<<eea85fb19a0c81ac68ce11d99d7f2f56>>
 * @relayHash 0660a223abd5ab709cdc24c6bff2221d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0660a223abd5ab709cdc24c6bff2221d

import { ConcreteRequest } from 'relay-runtime';
export type AdminMaybeCreateClientWorkspacePaymentAccountInput = {
  userId: string;
};
export type UserDetailsModalMutation$variables = {
  input: AdminMaybeCreateClientWorkspacePaymentAccountInput;
};
export type UserDetailsModalMutation$data = {
  readonly adminMaybeCreateClientWorkspacePaymentAccount: {
    readonly adminUserSearchResult: {
      readonly foreignWorkspaceStripeCustomerId: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
  };
};
export type UserDetailsModalMutation = {
  response: UserDetailsModalMutation$data;
  variables: UserDetailsModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "foreignWorkspaceStripeCustomerId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDetailsModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminMaybeCreateClientWorkspacePaymentAccountPayload",
        "kind": "LinkedField",
        "name": "adminMaybeCreateClientWorkspacePaymentAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUserSearchResult",
            "kind": "LinkedField",
            "name": "adminUserSearchResult",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserDetailsModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminMaybeCreateClientWorkspacePaymentAccountPayload",
        "kind": "LinkedField",
        "name": "adminMaybeCreateClientWorkspacePaymentAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUserSearchResult",
            "kind": "LinkedField",
            "name": "adminUserSearchResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0660a223abd5ab709cdc24c6bff2221d",
    "metadata": {},
    "name": "UserDetailsModalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bd470de36cc7530b5d8135fe5991b775";

export default node;
